import React from 'react'
import useStyles from './styles'
import classnames from 'clsx'
import { useFullScreen } from 'react-browser-hooks'
import { useSelector } from 'react-redux'

const Gradient = ({ children, classNames = {} }) => {
  const classes = useStyles()

  const windowFullscreen = useSelector(state => state.window.fullscreen)
  const { fullScreen } = useFullScreen()

  if (windowFullscreen || fullScreen) {
    return null
  } else {
    return <div className={classnames(classes.gradient, classNames)} />
  }
}

export default Gradient



// WEBPACK FOOTER //
// ./src/components/Gradient/index.jsx